export default {"src":"/_next/static/media/paypal-icon.875658b9.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};